import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeTermsAndConditionsSettingsCreate,
  detail: routeTermsAndConditionsSettingsDetail,
  home: routeTermsAndConditionsSettingsHome,
  root: routeTermsAndConditionsSettingsRoot,
} = createDoctypeRoutes({
  createName: 'new-terms-and-conditions',
  createPath: 'new-terms-and-conditions',
  detailName: 'terms-and-conditions-detail',
  doctype: DOCTYPES.TERMS_AND_CONDITIONS,
  homeName: 'terms-and-conditions',
  path: 'terms-and-conditions',
  views: {
    create: async () =>
      await import(
        '@/components/viewsExternal/settings/termsAndConditions/AddTermsAndConditions.vue'
      ),
    detail: async () =>
      await import(
        '@/components/viewsExternal/settings/termsAndConditions/ViewTermsAndConditions.vue'
      ),
    list: async () =>
      await import(
        '@/components/viewsExternal/settings/termsAndConditions/TermsAndConditionsView.vue'
      ),
  },
})

export {
  routeTermsAndConditionsSettingsCreate,
  routeTermsAndConditionsSettingsDetail,
  routeTermsAndConditionsSettingsHome,
  routeTermsAndConditionsSettingsRoot,
}
